/** Server sends Unix seconds for subscription period end. */
export function formatSubscriptionPeriodEndUnix(epochSeconds: number): string {
  return new Date(epochSeconds * 1000).toLocaleString(undefined, {
    dateStyle: 'medium',
    timeStyle: 'short',
  })
}
